'use client';
import { API_CONTACT_US } from '@/constant/apiRout';
import axios from '@/lib/axios';
import { pushToDataLayer } from '@/features/gtm/gtmUtils';
// import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { Call02Icon, Mail01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import React, { useState } from 'react';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa6';
const contactKeys = [
  'facebook_link',
  'instagram_link',
  'youtube_link',
  'doctor_appointment_phone',
  'contact_address',
  'contact_phone',
  'contact_email',
  'working_days',
];

const ContactForm = ({ data }) => {
  const contactData = data?.data?.reduce((acc, item) => {
    if (contactKeys.includes(item.type) && item.value) {
      acc[item.type] = item.value;
    }
    return acc;
  }, {});

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post(API_CONTACT_US, {
        name: formData.name,
        phone: formData.phone,
        message: formData.message,
      });

      if (response.data?.result) {
        setSubmitStatus('success');
        pushToDataLayer('generate_lead', { currency: 'BDT' });
        setFormData({ name: '', phone: '', message: '' }); // Reset form
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="contact padding-bottom">
        <div className="container">
          <div className="contact__wrapper">
            <div className="row g-5">
              <div className="col-lg-6">
                <div className="contact__info">
                  <h3>Contact Details</h3>
                  <div className="contact__details">
                    <div className="contact__item">
                      <div className="contact__item-inner">
                        <div className="contact__item-thumb">
                          <span>
                            <HugeiconsIcon icon={Call02Icon} />
                          </span>
                        </div>
                        <div className="contact__item-content">
                          <span>Emergency call</span>
                          <p>{contactData?.contact_phone}</p>
                        </div>
                      </div>
                    </div>
                    <div className="contact__item">
                      <div className="contact__item-inner">
                        <div className="contact__item-thumb">
                          <span>
                            <HugeiconsIcon icon={Mail01Icon} />
                          </span>
                        </div>
                        <div className="contact__item-content">
                          <span>General communication</span>
                          <p>{contactData?.contact_email}</p>
                        </div>
                      </div>
                    </div>
                    <div className="contact__address">
                      <div className="contact__address-item">
                        <h4>Store Address</h4>
                        <p className="w-100">{contactData?.contact_address}</p>
                      </div>
                      <div className="contact__address-item">
                        <h4>Social links</h4>
                        <ul className="social social--style2">
                          <li className="social__item">
                            <a
                              href={contactData?.facebook_link}
                              className="social__link social__link--style2"
                              target="_blank"
                            >
                              <FaFacebookF />
                            </a>
                          </li>
                          {/* <li className="social__item">
                            <a
                              href={contactData?.linkedin_link}
                              target="_blank"
                              className="social__link social__link--style2" target='_blank'
                            >
                              <FaLinkedinIn />
                            </a>
                          </li> */}
                          <li className="social__item">
                            <a
                              href={contactData?.youtube_link}
                              target="_blank"
                              className="social__link social__link--style2"
                            >
                              <FaYoutube />
                            </a>
                          </li>
                          <li className="social__item">
                            <a
                              href={contactData?.instagram_link}
                              target="_blank"
                              className="social__link social__link--style2"
                            >
                              <FaInstagram />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="contact__form">
                  <div className="contact__form-title">
                    <h2>Feel free to contact us</h2>
                  </div>
                  <form
                    action="/"
                    data-aos="fade-left"
                    data-aos-duration={1000}
                    onSubmit={handleSubmit}
                  >
                    <div className="row g-4">
                      <div className="col-12">
                        <div>
                          <label htmlFor="name" className="form-label">
                            Name
                          </label>
                          <input
                            className="form-control form-control--style2"
                            type="text"
                            id="name"
                            placeholder="Full Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div>
                          <label htmlFor="email" className="form-label">
                            Phone
                          </label>
                          <input
                            className="form-control form-control--style2"
                            type="tel"
                            id="phone"
                            placeholder="Phone number"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div>
                          <label htmlFor="textarea" className="form-label">
                            Message
                          </label>
                          <textarea
                            cols={30}
                            rows={5}
                            className="form-control form-control--style2"
                            id="message"
                            placeholder="Enter Your Message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    {submitStatus === 'success' && (
                      <div className="alert alert-success mt-3">
                        Thank you! Your message has been sent successfully.
                      </div>
                    )}
                    {submitStatus === 'error' && (
                      <div className="alert alert-danger mt-3">
                        There was an error submitting your message. Please try
                        again.
                      </div>
                    )}
                    <button
                      type="submit"
                      className="trk-btn trk-btn--border trk-btn--primary mt-4"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Sending...' : 'Send Messege'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
